export default __webpack_public_path__ + "static/media/note-line.9fd94a1c.svg";